export const closeModalPopupEvent = "close_modal_popup";
